<core-file-download-one-action-list
    [files]="files"
    [bubbles]="true"
    [actionStyle]="notesActionStyle"
    [actionText]="notesActionText"
    [bubbleTexts]="bubbleTexts"
    (actionClick)="onClick($event)"
></core-file-download-one-action-list>
